import type React from 'react';
import styles from './ErrorModal.module.scss';
import Icon from '../../../../stories/Atoms/Icon/Icon';
import { useTypedDispatch } from '../../Store/connectors';
import { removeError } from '../../Store/MetaData/action';
import Translation from '../../../general/Translation/Translation';

const ErrorModal: React.FC = () => {
  const dispatch = useTypedDispatch();
  const closeError = () => dispatch(removeError());
  return (
    <div className={styles.ErrorModal}>
      <Icon
        name="fa-triangle-exclamation"
        className={styles['ErrorModal__warning--icon']}
      />
      <div>
        <p className={styles['ErrorModal-title']}>
          <Translation
            pageString="checkout"
            stringId="error-modal-title"
          />
        </p>
        <p className={styles['ErrorModal-text']}>
          <Translation
            pageString="checkout"
            stringId="error-modal-text"
          />
        </p>
      </div>
      <button
        type="button"
        className={styles['ErrorModal__close-button']}
        onClick={closeError}
      >
        <Icon
          name="fa-xmark"
          className={styles['ErrorModal__close-icon']}
        />
      </button>
    </div>
  );
};

export default ErrorModal;
